import { render, staticRenderFns } from "./MappingRenewalForm.vue?vue&type=template&id=4cb3edba&"
import script from "./MappingRenewalForm.vue?vue&type=script&lang=js&"
export * from "./MappingRenewalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports